<template>
  <div class="contact-form">
    <h3 class="mb-3">Senden Sie uns eine Nachricht</h3>
    <div class="form-wrapper" :class="{ active: success }">
      <div class="alert alert-danger" v-if="errors && errors.errors">
        <b>Formular wurde nicht korrekt ausgefüllt:</b>
        <ul v-for="(errorMsgs, attr) in errors.errors">
          <li v-for="msg in errorMsgs">{{ msg }}</li>
        </ul>
      </div>
      <form role="form" @submit.prevent="send" id="form-contact">
        <div class="form-group">
          <label for="message">Nachricht </label><span class="required">*</span>
          <textarea
            id="message"
            name="body"
            cols="45"
            rows="8"
            aria-required="true"
            class="form-control"
            required
            v-model="form.message"
          ></textarea>
        </div>
        <div class="form-group">
          <label for="author">Name</label> <span class="required">*</span>
          <input
            id="author"
            name="name"
            type="text"
            value=""
            size="30"
            aria-required="true"
            class="form-control"
            required
            v-model="form.name"
          />
        </div>
        <div class="form-group">
          <label for="email">Email</label> <span class="required">*</span>
          <input
            id="email"
            name="email"
            type="email"
            value=""
            size="30"
            aria-required="true"
            class="form-control"
            required
            v-model="form.email"
          />
        </div>
        <div class="form-group">
          <label for="phone">Telefon</label>
          <input
            id="phone"
            name="phone"
            type="text"
            value=""
            size="30"
            aria-required="true"
            class="form-control"
            v-model="form.phone"
          />
        </div>
        <div>
          <input
            name="submit"
            type="submit"
            id="submit"
            value="Anfrage senden"
            class="btn btn-large"
          />
        </div>
      </form>
    </div>
    <div
      class="alert alert-success success-message"
      :class="{ active: success }"
    >
      <p><b>Ihre Nachricht ist bei uns eingetroffen.</b></p>
      <p>Wir werden uns baldmöglichst bei Ihnen melden.</p>
    </div>
  </div>
</template>
<script>
export default {
  data() {
    return {
      form: {
        phone: null,
        name: null,
        email: null,
        message: null,
      },
      errors: [],
      success: false,
    };
  },
  methods: {
    async send() {
      // this.$recaptcha('login').then((token) => {
      //     console.log(token) // Will print the token
      // TODO: send token so server for validation
      // })
      this.errors = [];
      try {
        const { data } = await axios.post(
          "https://deftly.novu.ch/api/r/mVfwR4OOXHkO73td?lang=de",
          this.form
        );
        this.success = true;
      } catch ({ response }) {
        if (response.status === 422) {
          this.errors = response.data;
        }
      }
    },
  },
};
</script>
<style scoped>
@keyframes fadeIn {
  from {
    opacity: 0;
  }
  to {
    opacity: 1;
  }
}

.success-message,
.form-wrapper.active {
  display: none;
}

.success-message.active {
  display: block;
  animation: fadeIn 0.8s;
}
</style>
